// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t3-0";
export var checkoutRateBadgeLink = "_t3-1";